import { render, staticRenderFns } from "./ProductListSib.vue?vue&type=template&id=6889423e&scoped=true"
import script from "./ProductListSib.vue?vue&type=script&lang=js"
export * from "./ProductListSib.vue?vue&type=script&lang=js"
import style0 from "./ProductListSib.vue?vue&type=style&index=0&id=6889423e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6889423e",
  null
  
)

export default component.exports